angular.
module("dx.webapp.lists").
directive("dxExamlist", function examlistDirective() {
	"use strict";

	return {
		restrict: "E",
		templateUrl: "tmpl/lists/examlist-directive.html",
		scope: {
			exams: "=",
			examLimit: "<",
			recentlyTouchedExamId: "<",
			searchSortOptions: "<",
			addExamToList: "<",
			removeExamFromList: "<",
		},
		controller: "DxExamlistController",
		controllerAs: "vm",
		bindToController: true,
	};
});
